// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonCustomerSupport_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6C12 3.79086 10.2091 2 8 2C5.79152 2 4.00107 3.78979 4 5.99803L4 12L0 11.3V5.7L2.03547 5.34379C2.36234 2.33879 4.90804 0 8 0C11.092 0 13.6377 2.33879 13.9645 5.34379L16 5.7V11.3L15 11.475V15.998H7V13.998H13V11.825L12 12V6Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 8.2L21.5449 7.70897C20.7718 3.32801 16.9464 0 12.3436 0C7.79104 0 3.99889 3.25593 3.16876 7.56625L0 8.2V17.8L6 19L6 7L5.33873 7.13226C6.2771 4.15714 9.05846 2 12.3436 2C15.6825 2 18.5009 4.22815 19.393 7.27861L18 7V19L20 18.6V21H16V20H9V24H16V23H22V18.2L24 17.8V8.2ZM20 9.43961V16.5604L22 16.1604V9.83961L20 9.43961ZM4 9.43961L4 16.5604L2 16.1604L2 9.83961L4 9.43961Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 0C22.7713 0 28.3335 5.17701 28.9443 11.7889L32 12.4V23.6L29 24.2V31H21V32H13V28H21V29H27V24.6L25 25V11L26.881 11.3762C26.096 6.07101 21.5234 2 16 2C10.4766 2 5.90396 6.07101 5.11902 11.3762L7 11L7 25L0 23.6V12.4L3.05567 11.7889C3.66652 5.17701 9.22868 0 16 0ZM27 13.4396V22.5604L30 21.9604V14.0396L27 13.4396ZM5 13.4396L5 22.5604L2 21.9604L2 14.0396L5 13.4396Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonCustomerSupport is a generated icon component.
 */
let IconCommonCustomerSupport = IconCommonCustomerSupport_1 = class IconCommonCustomerSupport extends IconBaseElement {
    render() {
        return html `${IconCommonCustomerSupport_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonCustomerSupport.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconCommonCustomerSupport = IconCommonCustomerSupport_1 = __decorate([
    customElement('zui-icon-common-customer-support')
], IconCommonCustomerSupport);
export { IconCommonCustomerSupport };
